import React from 'react';
import { Navigate } from 'react-router';
import { useAuth } from '../context/AuthContext';
import AdminLayout from '../layouts/AdminLayout';

const AdminProtectedRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user, initialized } = useAuth();

  // Show loading while checking auth
  if (!initialized || isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-holst-500"></div>
      </div>
    );
  }

  // Not authenticated - redirect to admin login page
  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  // Authenticated but not admin - redirect to home
  if (user?.role !== 'admin') {
    return <Navigate to="/" replace />;
  }

  // Admin user - wrap with AdminLayout and render children
  return (
    <AdminLayout>
      {children}
    </AdminLayout>
  );
};

export default AdminProtectedRoute;